import React from 'react';

var StepComplete = () => {
  return(
    <i className="fa fa-check"></i>
  );
};

export default StepComplete;
